import { is } from '@common/is/is'

import { Query } from '@common/Query/Query'

import type { ILocation, IQueryParams, IStatusResponse } from '../../definitions'

import globals from '../../globals'

import ajax from '../ajax'

/**
 * App státusz elkérése.
 * @param location - A location wrapper.
 */
export default async function getStatus (location: ILocation): Promise<IStatusResponse> {
  const base = globals.isProd
    ? `${ location.protocol }//${ location.hostname }`
    : ''

  const queryObj = {
    code: location.query.code ?? ''
  } satisfies IQueryParams

  const queryStr = Query.encode(queryObj)

  const url = `${ base }/api/check-status/${ globals.serial }?${ queryStr }`

  const response: IStatusResponse | null = (
    location.hostname.endsWith('.ro')
      ? await Promise.resolve(
        {
          isDemo: true,
          isBlocked: false,
          source: ''
        }
      )
      : await ajax<IStatusResponse>(url)
  )

  let data: IStatusResponse = {
    isDemo: false,
    isBlocked: true,
    source: ''
  }

  if (
    is.object(response) &&
    is.boolean(response?.isBlocked) &&
    is.boolean(response?.isDemo) &&
    is.string(response?.source)
  ) {
    data = response
  }

  return data
}
